import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import chatReducer from './chatSlice';
import componentDetailsReducer from './componentDetailsSlice';
import componentsReducer from './componentsSlice';
import inboxReducer from './inboxSlice';
import layoutReducer from './layoutSlice';
import manufacturersReducer from './manufacturersSlice';
import notificationsReducer from './notificationsSlice';
import orderDetailsReducer from './orderDetailsSlice';
import orderOperatorsReducer from './orderOperatorsSlice';
import orderProductionManagerReducer from './orderProductionManagerSlice';
import ordersCreatorReducer from './ordersCreatorSlice';
import ordersReducer from './ordersSlice';
import brandsReducer from './parameters/brandsSlice';
import categoriesReducer from './parameters/categoriesSlice';
import currenciesReducer from './parameters/currenciesSlice';
import elementsReducer from './parameters/elementsSlice';
import maintenanceReducer from './parameters/maintenanceSlice';
import productCategoriesReducer from './parameters/productCategoriesSlice';
import productCertificatesReducer from './parameters/productCertificatesSlice';
import productContinentsReducer from './parameters/productContinentsSlice';
import productCountriesReducer from './parameters/productCountriesSlice';
import productEventsReducer from './parameters/productEventsSlice';
import productFunctionsReducer from './parameters/productFunctionsSlice';
import productMainCategoriesReducer from './parameters/productMainCategoriesSlice';
import productSustainabilityReducer from './parameters/productSustainabilitySlice';
import seasonsReducer from './parameters/seasonsSlice';
import sizesReducer from './parameters/sizesSlice';
import statusesReducer from './parameters/statusesSlice';
import templatesReducer from './parameters/templatesSlice';
import specificationComponentsCostsReducer from './specificationComponentsCostsSlice';
import specificationComponentsReducer from './specificationComponentsSlice';
import specificationCostsReducer from './specificationCostsSlice';
import specificationDetailsReducer from './specificationDetailsSlice';
import specificationPreviewReducer from './specificationPreviewSlice';
import specificationProductionQuantitiesReducer from './specificationProductionQuantitiesSlice';
import specificationProjectionsReducer from './specificationProjectionsSlice';
import specificationsFoldersReducer from './specificationsFoldersSlice';
import specificationsMoveReducer from './specificationsMoveSlice';
import specificationsReducer from './specificationsSlice';
import suppliersReducer from './suppliersSlice';
import toastsReducer from './toastsSlice';
import userReducer from './userSlice';
import warehouseReleaseDetailsReducer from './warehouseReleaseDetailsSlice';
import warehouseReleasesReducer from './warehouseReleasesSlice';
const rootReducer = combineReducers({
    user: userReducer,
    layout: layoutReducer,
    toasts: toastsReducer,
    chat: chatReducer,
    inbox: inboxReducer,
    components: componentsReducer,
    componentDetails: componentDetailsReducer,
    notifications: notificationsReducer,
    orders: ordersReducer,
    ordersCreator: ordersCreatorReducer,
    orderDetails: orderDetailsReducer,
    orderOperators: orderOperatorsReducer,
    orderProductionManager: orderProductionManagerReducer,
    specificationComponentsCosts: specificationComponentsCostsReducer,
    specificationComponents: specificationComponentsReducer,
    specificationCosts: specificationCostsReducer,
    specificationDetails: specificationDetailsReducer,
    specificationPreview: specificationPreviewReducer,
    specificationProductionQuantities: specificationProductionQuantitiesReducer,
    specificationProjections: specificationProjectionsReducer,
    specificationsFolders: specificationsFoldersReducer,
    specificationsMove: specificationsMoveReducer,
    specifications: specificationsReducer,
    suppliers: suppliersReducer,
    manufacturers: manufacturersReducer,
    warehouseReleases: warehouseReleasesReducer,
    warehouseReleaseDetails: warehouseReleaseDetailsReducer,
    parameters: combineReducers({
        brands: brandsReducer,
        categories: categoriesReducer,
        seasons: seasonsReducer,
        statuses: statusesReducer,
        sizes: sizesReducer,
        elements: elementsReducer,
        templates: templatesReducer,
        currencies: currenciesReducer,
        maintenance: maintenanceReducer,
        productCategories: productCategoriesReducer,
        productCertificates: productCertificatesReducer,
        productContinents: productContinentsReducer,
        productCountries: productCountriesReducer,
        productEvents: productEventsReducer,
        productFunctions: productFunctionsReducer,
        productMainCategories: productMainCategoriesReducer,
        productSustainability: productSustainabilityReducer,
    }),
});
export const setupStore = (preloadedState) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['toasts/addNewToast'],
                ignoredActionPaths: ['payload.description'],
                ignoredPaths: ['toasts.toasts'],
            },
        }),
    });
};
export const useAppDispatch = useDispatch;
export { brandsReducer, categoriesReducer, chatReducer, componentDetailsReducer, componentsReducer, inboxReducer, layoutReducer, notificationsReducer, orderDetailsReducer, orderOperatorsReducer, orderProductionManagerReducer, ordersCreatorReducer, ordersReducer, productCategoriesReducer, productCertificatesReducer, productContinentsReducer, productEventsReducer, productFunctionsReducer, productMainCategoriesReducer, productSustainabilityReducer, seasonsReducer, specificationComponentsCostsReducer, specificationComponentsReducer, specificationCostsReducer, specificationDetailsReducer, specificationPreviewReducer, specificationProductionQuantitiesReducer, specificationProjectionsReducer, specificationsFoldersReducer, specificationsMoveReducer, specificationsReducer, statusesReducer, suppliersReducer, toastsReducer, userReducer, warehouseReleasesReducer, };
const store = setupStore();
export default store;
